/* eslint-disable no-constant-condition */
import RoundCheckBox from '../../components/CustomCheckbox/RoundCheckbox';
import Select from 'react-select';
import classNames from 'classnames';
import loadingGif from '../../assets/Other/loading.gif';
import { useEffect, useState } from 'react';
import CVItem from '../../components/CV/CVItem';
import {
  controllers,
  requestTypes,
  responseTypes,
} from '../../constants/enums/API';
import request from '../../utils/APIHelper/request';
import Table from '../../components/Table/Table';
import { branchNamesCaliforniaIncluded } from '../../constants/enums/RefundContacts';
import { toast } from 'react-toastify';
import ShipmentWindow from '../../components/ShipmentWindow/ShipmentWindow';
import { getShippingServiceName } from '../../utils/ShippingServices/ShippingServices';
import { parcelStatuses } from '../../constants/enums/ParcelStatuses';
import TwoOptionSwitch from '../../components/TwoOptionSwitch/TwoOptionSwitch';
import { Tooltip } from 'react-tooltip';
import queryString from 'query-string';
import { Link, useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import ReactPaginate from 'react-paginate';
import { currentUser, shipmentsReadOnly } from '../../utils/Auth/auth';
import ShipmentWindowReadOnly from '../../components/ShipmentWindow/ShipmentWindowReadOnly';
import useScreenSize from '../../utils/UseScreenSize/UseScreenSize';

const userType = (user) => {
  switch (user) {
    case 'OOREG' || 'OODOV':
      return <span className="text-blue-600">Online Registraion</span>;
    case 'GUEST':
      return <span className="text-orange-500">Guest Shipping</span>;
    default:
      return <span className="text-green-600">Agent</span>;
  }
};

const parcelStatus = (status) => {
  switch (status) {
    case parcelStatuses.created:
      return <span className="text-pink-400">{status}</span>;
    case parcelStatuses.uploaded:
      return <span className="text-blue-600">{status}</span>;
    case parcelStatuses.invoiced:
      return <span className="text-orange-500">{status}</span>;
    case parcelStatuses.void:
      return <span className="text-gray-400">{status}</span>;
    default:
      return <span className="text-green-600">{status}</span>;
  }
};

const ShipmentsInfo = ({ swalModal }) => {
  const screenWidth = useScreenSize();
  const [invoicedButtonLoading, setInvoicedButtonLoading] = useState(false);
  const [outOfStatementButtonLoading, setOutOfStatementButtonLoading] =
    useState(false);
  const [CVs, setCVs] = useState([]);
  const [CVInput, SetCVInput] = useState('');
  const [shipments, setShipments] = useState([]);
  const [selectedCVs, setSelectedCVs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingCV, setLoadingCV] = useState(0);
  const [searchBy, setSearchBy] = useState(null);
  // Search by params options
  const [pageCount, setPageCount] = useState();
  const [totalItems, setTotalItems] = useState();
  const [branch, setBranch] = useState(null);
  const [agent, setAgent] = useState(null);
  const [agentList, setAgentList] = useState(null);
  const [container, setContainer] = useState(null);
  const [statement, setStatement] = useState(null);
  const [firstName, setFirstName] = useState(null);
  const [lastName, setLastName] = useState(null);
  const [email, setEmail] = useState(null);
  const [phone, setPhone] = useState(null);

  const { search } = useLocation();
  const navigate = useNavigate();
  const params = queryString.parse(search);
  //
  const branchOptions = [
    {
      value: '1',
      label: '1 - Canada',
      isDisabled:
        !currentUser.branches.includes('1') &&
        !currentUser.baseBranch.includes('1'),
    },
    {
      value: '2',
      label: '2 - New Jersey',
      isDisabled:
        !currentUser.branches.includes('2') &&
        !currentUser.baseBranch.includes('2'),
    },
    {
      value: '3',
      label: '3 - Los Angeles',
      isDisabled:
        !currentUser.branches.includes('3') &&
        !currentUser.baseBranch.includes('3'),
    },
    {
      value: '4',
      label: '4 - Chicago',
      isDisabled:
        !currentUser.branches.includes('4') &&
        !currentUser.baseBranch.includes('4'),
    },
  ];

  const setBranchOnPageLoading = async (selectedBranch) => {
    if (selectedBranch) {
      const result = await request({
        url: `${controllers.agent}getAgentsByBranch`,
        type: requestTypes.post,
        params: { branchId: selectedBranch.value },
      });
      const agents = result?.map((a) => ({ value: a, label: a }));
      setAgentList(agents);
    } else {
      setAgentList([]);
    }
    setBranch(selectedBranch);
  };

  useEffect(() => {
    setSearchBy(params.searchBy || 'CV');
    setBranchOnPageLoading(
      branchOptions.find((option) => option.value === params.branch),
      params.agent,
    );
    setContainer(params.container);
    setStatement(params.statement);
    setFirstName(params.firstName);
    setLastName(params.lastName);
    setEmail(params.email);
    setPhone(params.phone);
    setAgent(
      params.agent ? { value: params.agent, label: params.agent } : null,
    );
  }, []);

  useEffect(() => {
    const isValid =
      params.branch ||
      params.agent ||
      params.container ||
      params.firstName ||
      params.lastName ||
      params.email ||
      params.phone ||
      params.statement;
    const fetchData = async () => {
      if (params.searchBy === 'Params' && isValid) {
        setShipments([]);
        setSelectedCVs([]);
        const result = await request({
          url: `${controllers.shipments}getShipmentsByParams`,
          type: requestTypes.post,
          body: {
            page: params.page,
            branch: params.branch,
            customerCd: params.agent,
            container: params.container,
            firstName: params.firstName,
            lastName: params.lastName,
            email: params.email,
            phone: params.phone,
            statement: params.statement,
          },
          setLoading,
        });
        if (result.code !== responseTypes.error) {
          setShipments(result.shipments);
          setPageCount(result.totalPages);
          const pageDoesNotExist =
            parseInt(params.page) > parseInt(result.totalPages);

          if (pageDoesNotExist && parseInt(result.totalPages) > 0) {
            const urlParams = new URLSearchParams(location.search);
            urlParams.set('page', result.totalPages);
            navigate(`${location.pathname}?${urlParams.toString()}`);
          }
          setTotalItems(result.totalCount);
        } else {
          showSwal(result.code.toLowerCase());
        }
      }
    };

    fetchData();
  }, [search]);

  const onEnterMethod = () => {
    const trimmedCVInput = CVInput.trim().toUpperCase();

    const sanitizedInput = trimmedCVInput.replace(/[^A-Z0-9]/g, '');

    if (
      sanitizedInput.length > 0 &&
      !CVs.includes(sanitizedInput) &&
      CVs.length < 10
    ) {
      setCVs([...CVs, sanitizedInput]);
      SetCVInput('');
    }
  };

  const selectAll = (empty) => {
    if (empty) {
      const cvs = shipments.map((item) => item?.id);
      setSelectedCVs(cvs);
    } else {
      setSelectedCVs([]);
    }
  };

  const selectCV = (CV) => {
    if (!selectedCVs.includes(CV)) {
      setSelectedCVs([...selectedCVs, CV]);
    } else {
      setSelectedCVs(selectedCVs.filter((selectedCV) => selectedCV !== CV));
    }
  };

  const showShipmentWindow = async (shipment) => {
    const id = shipment.id;
    setLoadingCV(id);
    const result = await request({
      url: `${controllers.shipments}getShipment`,
      type: requestTypes.post,
      params: { id },
    });
    setLoadingCV(null);
    swalModal.fire({
      title: `Shipment ${shipment.codeA}`,
      html: shipmentsReadOnly ? (
        <ShipmentWindowReadOnly data={result} />
      ) : (
        <ShipmentWindow
          reloadAfterUpdate={params.searchBy === 'Params'}
          updateData={setShipments}
          data={shipments}
          shipmentData={result}
        />
      ),
      showConfirmButton: false,
      showCancelButton: true,
      confirmButtonText: 'Save',
      cancelButtonText: 'Close',
      customClass: {
        cancelButton:
          'bg-gray-300 text-gray-800 hover:bg-gray-400 font-normal text-sm',
        actions: 'flex justify-end w-full px-[23px]',
        popup: 'w-[95vw] min-h-[90vh]',
      },
    });
  };

  const setSearchByWithNavigation = (option) => {
    if (searchBy !== option) {
      setBranch(null);
      setAgent(null);
      setAgentList([]);
      setContainer(null);
      setStatement(null);
      setFirstName(null);
      setLastName(null);
      setEmail(null);
      setPhone(null);
      setPageCount(null);
      setTotalItems(null);
      navigate('/shipmentsInfo');
      setSearchBy(option);
      setSelectedCVs([]);
      setCVs([]);
      setShipments([]);
    }
  };

  const filterShipmentsData = (data) => {
    return data.map((item) => {
      return {
        select: {
          element: (
            <div className="flex justify-center">
              <RoundCheckBox
                size={0.8}
                value={selectedCVs.some((i) => i === item?.id)}
                changeFieldValue={() => selectCV(item?.id)}
                previousValue={false}
              />
            </div>
          ),
        },
        number: item?.codeA || (
          <span className="text-red-500 font-semibold">NULL !!!</span>
        ),
        type: item?.shipmentType,
        status: parcelStatus(item?.status),
        department: {
          element: branchNamesCaliforniaIncluded[item?.branchId] || '---',
        },
        user: item?.customerCd || '---',
        userType: userType(item?.customerCd),
        price: `${item?.custOwn.toFixed(2)} ${item?.currencyCd}`,
        container: item?.container || '--Not in container--',
        statement: item?.statementName || '--not in statement--',
        shippingService:
          getShippingServiceName(item?.serviceCode) || '--not visible yet--',
        edit: (
          <div className="text-center">
            <span
              onClick={() => showShipmentWindow(item)}
              className={classNames(
                'rounded-xl bg-blue-800 text-white px-2 cursor-pointer hover:bg-blue-900 hover:transition-all hover:duration-300',
                loadingCV === item.id ? 'hidden' : null,
              )}
            >
              DETAILS
            </span>
            <img
              src={loadingGif}
              className={classNames(
                'sm:w-3 sm:h-3 md:w-5 md:h-5 w-2 h-2 mx-auto',
                loadingCV !== item.id ? 'hidden' : null,
              )}
            />
          </div>
        ),
      };
    });
  };

  const headers = [
    <div key="select-cv" className="flex justify-center">
      <div className="inline-block mr-2">Select All</div>
      <RoundCheckBox
        size={0.8}
        value={selectedCVs.length === shipments.map((i) => i.codeA).length}
        previousValue={false}
        changeFieldValue={(e) => selectAll(e)}
      />
    </div>,
    'Code/CV',
    'Type',
    'Status',
    'Department',
    'User',
    'User Type',
    'Price',
    'Container',
    'Statement',
    'Shipping Service',
    <div key={'view-or-edit'} className="text-center w-full">
      {'View or edit'}
    </div>,
  ];

  const onRemoveMethod = (index) => {
    setCVs(CVs.filter((_, i) => i !== index));
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      onEnterMethod();
    }
  };

  const showSwal = (code) => {
    swalModal.fire({
      title: 'Payment was not proceeded!',
      text: `Payment was not proceed for parcels ${CVs.join(', ')}`,
      icon: code,
      showCancelButton: true,
      showConfirmButton: false,
      cancelButtonText: 'Cancel',
      customClass: {
        confirmButton: 'bg-blue-800 text-white hover:bg-blue-900',
        cancelButton: 'bg-gray-300 text-gray-800 hover:bg-gray-400',
        popup: 'w-[400px] text-sm',
      },
    });
  };

  const changeBranch = async (selectedBranch) => {
    if (selectedBranch) {
      const result = await request({
        url: `${controllers.agent}getAgentsByBranch`,
        type: requestTypes.post,
        params: { branchId: selectedBranch.value },
      });
      const agents = result?.map((a) => ({ value: a, label: a }));
      setAgentList(agents);
    } else {
      setAgentList([]);
    }
    setAgent(null);
    setBranch(selectedBranch);
  };

  const download = async () => {
    setShipments([]);
    setSelectedCVs([]);
    if (CVs.length > 0) {
      const result = await request({
        url: `${controllers.shipments}getShipments`,
        type: requestTypes.post,
        body: CVs,
        setLoading,
      });

      if (result.code !== responseTypes.error) {
        const foundShipments = CVs.map((cv) => {
          return result.find((sh) => sh.codeA === cv);
        }).filter((x) => !!x);
        setShipments(foundShipments);
      } else {
        showSwal(result.code.toLowerCase());
      }
    }
  };

  const pullOutOfStatement = async () => {
    if (selectedCVs.length > 0 && !outOfStatementButtonLoading) {
      setShipments((prevShipments) =>
        prevShipments.map((item) =>
          selectedCVs.includes(item?.id)
            ? { ...item, statementName: null }
            : item,
        ),
      );
      const result = await request({
        url: `${controllers.shipments}pullOutOfStatement`,
        type: requestTypes.post,
        body: selectedCVs,
        setLoading: setOutOfStatementButtonLoading,
      });

      if (result.code !== responseTypes.error) {
        if (searchBy === 'Params') {
          window.location.reload();
        } else {
          toast.info(
            `Pulled parcel/s ${selectedCVs.join(', ')} out of statement`,
            {
              autoClose: 2000,
            },
          );
        }
      } else {
        showSwal(result.code.toLowerCase());
      }
    }
  };

  const makeInvoiced = async () => {
    if (selectedCVs.length > 0 && !invoicedButtonLoading) {
      setShipments((prevShipments) =>
        prevShipments.map((item) =>
          selectedCVs.includes(item?.id)
            ? { ...item, status: 'INVOICED' }
            : item,
        ),
      );
      const result = await request({
        url: `${controllers.shipments}makeInvoiced`,
        type: requestTypes.post,
        body: selectedCVs,
        setLoading: setInvoicedButtonLoading,
      });

      if (result.code !== responseTypes.error) {
        toast.info(`Made parcel/s ${selectedCVs.join(', ')} invoiced`, {
          autoClose: 2000,
        });
      } else {
        showSwal(result.code.toLowerCase());
      }
    }
  };

  const getQueryParamsByPage = (pageNum) => {
    return {
      ...(searchBy && { searchBy }),
      ...(branch && { branch: branch.value }),
      ...(agent && { agent: agent.value }),
      ...(container && { container }),
      ...(statement && { statement }),
      ...(firstName && { firstName }),
      ...(lastName && { lastName }),
      ...(email && { email }),
      ...(phone && { phone }),
      ...{ page: pageNum },
    };
  };

  const getPaginationParams = (pageNum) => {
    return {
      ...(params.searchBy && { searchBy: params.searchBy }),
      ...(params.branch && { branch: params.branch }),
      ...(params.agent && { agent: params.agent }),
      ...(params.container && { container: params.container }),
      ...(params.statement && { statement: params.statement }),
      ...(params.firstName && { firstName: params.firstName }),
      ...(params.lastName && { lastName: params.lastName }),
      ...(params.email && { email: params.email }),
      ...(params.phone && { phone: params.phone }),
      ...{ page: pageNum },
    };
  };

  const paramsAreSet = () => {
    const value = {
      ...(branch && { branch: branch.value }),
      ...(agent && branch && { agent: agent.value }),
      ...(container && { container }),
      ...(statement && { statement }),
      ...(firstName && { firstName }),
      ...(lastName && { lastName }),
      ...(email && { email }),
      ...(phone && { phone }),
    };
    const areSet = queryString.stringify(value)?.length > 0;
    return areSet;
  };

  const searchPanel = (value) => {
    return value === 'CV' ? (
      <div className="w-1/2 xl:w-[500px] min-h-[110px] mx-auto xl:ml-20 my-10 xl:my-0 relative">
        <input
          value={CVInput}
          onKeyDown={handleKeyPress}
          onChange={(e) => SetCVInput(e.target.value)}
          type="text"
          placeholder="Enter CV..."
          className="w-[90%] p-2 border-b border-b-blue-700 rounded-t-[20px] focus:outline-none focus:border-blue-400 text-xs"
        />
        <div
          onClick={onEnterMethod}
          className="absolute text-white bg-blue-900 p-[8.5px] px-4 top-0 right-0 text-xs cursor-pointer rounded-r-xl rounded-tl-xl"
        >
          ENTER
        </div>
        <div className="w-full text-left px-2 py-1 text-sm pb-10">
          {CVs.map((item, index) => {
            return (
              <CVItem
                key={index}
                number={item}
                onRemove={() => onRemoveMethod(index)}
              />
            );
          })}
        </div>
        <div className="absolute bottom-1 w-full text-right">
          <div
            onClick={download}
            className={classNames(
              'bg-red-800 text-white inline-block px-10 rounded-[20px] cursor-pointer hover:bg-red-900 hover:transition-all hover:duration-300 text-sm xl:text-sm',
              loading ? 'hidden' : null,
            )}
          >
            SEARCH
          </div>
          <div
            className={classNames(
              'w-full flex justify-end items-center pr-[60px]',
              !loading ? 'hidden' : null,
            )}
          >
            <img className="w-8 h-8" src={loadingGif} />
          </div>
        </div>
      </div>
    ) : (
      <>
        <div className="text-blue-800 w-full m-3">
          <div className="text-[0.7rem] lg:text-xs">
            <div className="w-[255px] inline-block items-center mt-5 px-8">
              <div className="">Branch:</div>
              <Select
                value={branch}
                onChange={(selected) => changeBranch(selected)}
                options={branchOptions}
                className="min-w-0 flex-grow text-left"
                placeholder="Choose branch..."
                isClearable={true}
              />
            </div>
            <div className="w-[255px] inline-block items-center mt-5  px-8">
              <div className="">Agent:</div>
              <div
                className="min-w-0 flex-grow text-left"
                data-tooltip-id="my-tooltip"
                data-tooltip-content={
                  !branch ? 'Need to select branch first' : null
                }
              >
                {' '}
                <Select
                  value={agent}
                  isDisabled={!branch}
                  onChange={(selected) => setAgent(selected)}
                  options={agentList}
                  placeholder="Choose agent..."
                  isClearable={true}
                />
              </div>

              <Tooltip id="my-tooltip" />
            </div>
            <div className="w-[255px] inline-block items-center mt-5">
              <div className="">Container:</div>
              <input
                value={container}
                onChange={(e) => setContainer(e.target.value)}
                className="border-b-[1px] border-blue-800 px-4 focus:outline-none focus:border-b-[1px] focus:border-blue-400 min-w-0 flex-grow"
                placeholder="1212A..."
                type="text"
              />
            </div>
            <div className="w-[255px] inline-block items-center mt-5">
              <div className=" w-auto mr-2">Statement:</div>
              <input
                value={statement}
                onChange={(e) => setStatement(e.target.value)}
                className="border-b-[1px] border-blue-800 px-4 focus:outline-none focus:border-b-[1px] focus:border-blue-400 min-w-0 flex-grow"
                placeholder="P1111..."
                type="text"
              />
            </div>
            <div className="mt-6">{`Sender's info`}</div>
            <div className="w-[255px] inline-block items-center mt-5">
              <div className="">First name:</div>
              <input
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                className="border-b-[1px] border-blue-800 px-4 focus:outline-none focus:border-b-[1px] focus:border-blue-400 min-w-0 flex-grow"
                placeholder="First name..."
                type="text"
              />
            </div>
            <div className="w-[255px] inline-block items-center mt-5">
              <div className="">Last name:</div>
              <input
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                className="border-b-[1px] border-blue-800 px-4 focus:outline-none focus:border-b-[1px] focus:border-blue-400 min-w-0 flex-grow"
                placeholder="Last name..."
                type="text"
              />
            </div>

            <div className="w-[255px] inline-block items-center mt-5">
              <div className=" w-auto mr-2">Email:</div>
              <input
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="border-b-[1px] border-blue-800 px-4 focus:outline-none focus:border-b-[1px] focus:border-blue-400 min-w-0 flex-grow"
                placeholder="your@example.com..."
                type="text"
              />
            </div>

            <div className="w-[255px] inline-block items-center mt-5">
              <div className=" w-auto mr-2">Phone:</div>
              <input
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                className="border-b-[1px] border-blue-800 px-4 focus:outline-none focus:border-b-[1px] focus:border-blue-400 min-w-0 flex-grow"
                placeholder="Phone..."
                type="text"
              />
            </div>
          </div>
        </div>
        <div className="my-5 w-full h-10 flex justify-center items-center">
          <Link
            onClick={(e) => {
              if (loading || !paramsAreSet()) e.preventDefault();
            }}
            to={`/shipmentsinfo?${queryString.stringify(getQueryParamsByPage(1))}`}
            className={classNames(
              'bg-red-800 text-white inline-block px-10 rounded-[20px] cursor-pointer hover:bg-red-900 hover:transition-all hover:duration-300 text-sm xl:text-md',
              loading || !paramsAreSet() ? '!bg-gray-500' : null,
            )}
          >
            SEARCH
          </Link>
        </div>
      </>
    );
  };

  return (
    <div>
      <div className="text-blue-900 text-xs lg:text-lg">Search by:</div>
      <TwoOptionSwitch
        firstOption={'CV'}
        secondOption={'Params'}
        value={searchBy}
        setValue={setSearchByWithNavigation}
      />
      <br />
      <div className=""> {searchPanel(searchBy)}</div>
      <div className="w-full">
        {' '}
        {searchBy === 'Params' ? (
          <ReactPaginate
            onPageChange={(e) => {
              const redirectPage = Number.parseInt(e.selected) + 1;
              navigate(
                `/shipmentsInfo?${queryString.stringify(getPaginationParams(redirectPage))}`,
              );
            }}
            forcePage={Number.parseInt(params.page) - 1 || 0}
            pageCount={pageCount}
            pageRangeDisplayed={4}
            marginPagesDisplayed={2}
            containerClassName={classNames(
              'inline-flex flex-row w-1/2 float-left my-0 text-sm xl:text-sm',
              searchBy === 'Params' ? null : 'hidden',
            )}
            activeLinkClassName="!text-blue-400 !border-blue-400"
            pageLinkClassName="mx-3 text-blue-700 border-[1px] border-blue-700 rounded-xl min-w-[20px] px-[5px] xl:px-2 py-[1px] xl:py-[1px] hover:text-blue-400 hover:border-blue-400 hover:duration-300"
            previousLinkClassName="mx-3 text-blue-700 border-[1px] border-blue-700 rounded-xl min-w-[20px] px-[5px] xl:px-2 py-[1px] xl:py-[1px] hover:text-blue-400 hover:border-blue-400 hover:duration-300"
            nextLinkClassName="mx-3 text-blue-700 border-[1px] border-blue-700 rounded-xl min-w-[20px] px-[5px] xl:px-2 py-[1px] xl:py-[1px] hover:text-blue-400 hover:border-blue-400 hover:duration-300"
          />
        ) : (
          <></>
        )}
      </div>
      <br />
      <div className="w-full mx-auto pb-20 text-center">
        <div className="text-right my-5">
          <div
            onClick={pullOutOfStatement}
            className={classNames(
              shipmentsReadOnly && 'hidden',
              'inline-block text-white rounded-xl px-4 mx-3 text-[0.5rem] lg:text-sm xl:text-sm relative',
              selectedCVs.length > 0
                ? ' bg-blue-800 hover:bg-blue-900 hover:transition-all hover:duration-300 cursor-pointer'
                : 'bg-gray-400',
              outOfStatementButtonLoading && '!bg-transparent !cursor-auto',
            )}
          >
            <span
              className={classNames(
                outOfStatementButtonLoading && '!invisible',
              )}
            >
              Pull out of statement
            </span>
            <img
              className={classNames(
                ' absolute top-[0.15rem] left-[45%] w-4 h-4',
                !outOfStatementButtonLoading && 'hidden',
              )}
              src={loadingGif}
            ></img>
          </div>
          <div
            onClick={makeInvoiced}
            className={classNames(
              shipmentsReadOnly && 'hidden',
              'inline-block text-white rounded-xl px-4 mx-3 text-[0.5rem] lg:text-sm xl:text-sm relative',
              selectedCVs.length > 0
                ? ' bg-blue-800 hover:bg-blue-900 hover:transition-all hover:duration-300 cursor-pointer'
                : 'bg-gray-400',
              invoicedButtonLoading && '!bg-transparent !cursor-auto',
            )}
          >
            <span className={classNames(invoicedButtonLoading && '!invisible')}>
              Make INVOICED
            </span>
            <img
              className={classNames(
                ' absolute top-[0.15rem] left-[45%] w-4 h-4',
                !invoicedButtonLoading && 'hidden',
              )}
              src={loadingGif}
            ></img>
          </div>
        </div>
        {searchBy === 'Params' ? (
          <div
            className={classNames(
              shipmentsReadOnly && 'pt-5',
              'text-left m-4 text-blue-800 text-sm xl:text-sm',
            )}
          >
            <span className={classNames(!shipmentsReadOnly && 'hidden')}>
              <br />
            </span>
            Total: {totalItems}
          </div>
        ) : null}
        <div
          className={classNames(
            loading && searchBy === 'Params'
              ? 'flex justify-center items-center'
              : 'hidden',
          )}
        >
          <img className="w-8 h-8" src={loadingGif} />
          {/* <div className="text-sm mx-2 text-gray-500">Searching...</div> */}
        </div>
        <Table
          headers={headers}
          data={filterShipmentsData(shipments)}
          rowsClassName="text-[1.5vw] md:text-[1vw] font-semibold xl:font-normal xl:text-xs 2xl:text-sm"
          headersClassNames="text-[1.5vw] md:text-[1vw] xl:font-normal xl:text-xs 2xl:text-sm"
          hiddenColumns={screenWidth < 800 ? [2, 8, 10] : []}
        />
      </div>
    </div>
  );
};

export default ShipmentsInfo;
